import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  initials: 'AG',
  name: 'Ana G.',
  loc: 'Mendoza',
  age: '35 años',
  text: 'Dejé de vivir con la panza hinchada todo el día. Ahora sé exactamente qué me inflama y qué no. Es una libertad enorme.',
  color: 'bg-pink-600'
}, {
  initials: 'VM',
  name: 'Valeria M.',
  loc: 'Buenos Aires',
  age: '29 años',
  text: 'El protocolo del nervio vago es oro puro. Lo uso cuando siento que colapso y en 2 minutos mi cuerpo se calma. Increíble.',
  color: 'bg-blue-600'
}, {
  initials: 'PC',
  name: 'Paula C.',
  loc: 'La Plata',
  age: '42 años',
  text: 'Recuperé mi energía sin tomar café todo el día. Me levanto descansada y llego a la noche sin arrastrarme.',
  color: 'bg-purple-600'
}, {
  initials: 'CA',
  name: 'Carolina A.',
  loc: 'Rosario',
  age: '31 años',
  text: 'Los primeros 3 días fueron un cambio brutal. Mi panza se desinflamó y mi ansiedad bajó notablemente. Seguí con el plan de 21 días y ahora es mi estilo de vida.',
  color: 'bg-emerald-600'
}];
export function MoreTestimonials() {
  return <section className="py-20 bg-brand-cream" data-id="element-222">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-223">
        <FadeIn className="text-center mb-12" data-id="element-224">
          <div className="inline-flex items-center justify-center p-3 bg-brand-card rounded-full mb-4 shadow-sm" data-id="element-225">
            <Heart className="w-6 h-6 text-brand-terracotta" data-id="element-226" />
          </div>
          <h2 className="text-3xl font-bold" data-id="element-227">MÁS MUJERES QUE YA LO TIENEN</h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-228">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-brand-card border border-brand-border border-l-[3px] border-l-brand-terracotta p-6 rounded-2xl shadow-sm" data-id="element-229">
              <div className="flex items-center gap-1 mb-4" data-id="element-230">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-terracotta text-brand-terracotta" data-id="element-231" />)}
              </div>
              <p className="text-brand-dark mb-6 italic leading-relaxed" data-id="element-232">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-brand-border" data-id="element-233">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white shrink-0 ${t.color}`} data-id="element-234">
                  {t.initials}
                </div>
                <div data-id="element-235">
                  <div className="font-bold text-sm text-brand-dark" data-id="element-236">
                    {t.name}{' '}
                    <span className="text-brand-muted font-normal" data-id="element-237">
                      📍 {t.loc}
                    </span>
                  </div>
                  <div className="text-xs text-brand-muted" data-id="element-238">{t.age}</div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}